import React, { useState } from 'react'
import { Button, Input, Tooltip, message } from 'antd'
import { InfoCircleOutlined, RobotOutlined } from '@ant-design/icons'
import { generateRectifyDescription } from '../services/aiService'

const { TextArea } = Input

interface AIDescriptionGeneratorProps {
  imageUrls: string[]
  onApply: (text: string) => void
  userId?: string | number | null
}

const AIDescriptionGenerator: React.FC<AIDescriptionGeneratorProps> = ({
  imageUrls,
  onApply,
  userId
}) => {
  const [intention, setIntention] = useState('')
  const [streamContent, setStreamContent] = useState('')
  const [latestResult, setLatestResult] = useState('')
  const [loading, setLoading] = useState(false)

  const handleGenerate = async () => {
    if (!imageUrls || imageUrls.length === 0) {
      message.warning('请先上传或选择照片，再使用AI描述')
      return
    }

    setLoading(true)
    setStreamContent('')
    setLatestResult('')

    try {
      const result = await generateRectifyDescription({
        imageUrls,
        intention,
        userId,
        onStreamUpdate: (text) => {
          setStreamContent(text)
        }
      })

      setLatestResult(result)
      message.success('AI描述生成成功，已自动填入，可继续编辑')
      onApply(result)
    } catch (error) {
      console.error('AI生成整改描述失败:', error)
      message.error((error as Error).message || 'AI生成失败，请稍后重试')
    } finally {
      setLoading(false)
    }
  }

  const handleReapply = () => {
    if (!latestResult) {
      message.info('暂无可应用的AI内容，请先生成')
      return
    }
    onApply(latestResult)
    message.success('已重新填充AI描述')
  }

  return (
    <div className="ai-description-panel">
      <div className="panel-header">
        <div className="title">
          <RobotOutlined />
          <span>AI智能描述</span>
        </div>
        <Tooltip title="AI会参考所选照片内容，生成整改说明，可继续手动编辑">
          <span>
            <InfoCircleOutlined />
          </span>
        </Tooltip>
      </div>

      <div className="intention-input">
        <div className="label">生成要求（选填）</div>
        <TextArea
          rows={2}
          maxLength={100}
          placeholder="例如：强调安全风险，输出整改措施要具体可执行"
          value={intention}
          onChange={(e) => setIntention(e.target.value)}
        />
      </div>

      <div className="action-row">
        <Button
          type="primary"
          onClick={handleGenerate}
          loading={loading}
          disabled={loading}
        >
          {loading ? 'AI生成中...' : 'AI一键生成'}
        </Button>
        <Button onClick={handleReapply} disabled={!latestResult || loading}>
          回填上次结果
        </Button>
      </div>

      {streamContent && (
        <div className="stream-output">
          <div className="label">实时生成结果</div>
          <div className="content">{streamContent}</div>
        </div>
      )}
    </div>
  )
}

export default AIDescriptionGenerator
